export default {
  'HOTEL' (state) {
    return state.hotel
  },
  'HOTELS' (state) {
    return state.hotels
  }
}
